import {
  CircleLayerSpecification,
  FillLayerSpecification,
  LineLayerSpecification
} from 'maplibre-gl';
import type Graphic from "@arcgis/core/Graphic";

export type HighlightStrategy = {
  type: 'fill' | 'line' | 'circle';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paint: any;
};

export type HighlightSelectionSpecification =
  | CircleLayerSpecification
  | LineLayerSpecification
  | FillLayerSpecification;

export const EID_FILTER = (graphic: Graphic) => [
  'all',
  ['has', 'eid'],
  ['==', 'eid', graphic.getAttribute('eid')]
];
export const ICAO_FILTER = (graphic: Graphic) => [
  'all',
  ['has', 'icao'],
  ['==', 'icao', graphic.getAttribute('icao')]
];
export const FIXEID_FILTER = (graphic: Graphic) => [
  'all',
  ['has', 'fixeid'],
  ['==', 'fixeid', graphic.getAttribute('fixeid')]
];
export const ID_FILTER = (graphic: Graphic) => [
  'all',
  ['has', 'identifier'],
  ['==', 'identifier', graphic.getAttribute('identifier')]
];
export const AMDB_FILTER = (graphic: Graphic) => [
  'all',
  ['has', 'airporteid', 'runwayident'],
  ['==', 'airporteid', graphic.getAttribute('airporteid')],
  ['==', 'runwayident', graphic.getAttribute('runwayident')]
];

export const SELECTION_COLOR = 'rgb(0, 155, 222)';
export const SELECTION_COLOR_TRANSPARENT = 'rgba(0, 155, 222, 0.5)';

export const LINE_SELECTION_STYLE = {
  'line-color': SELECTION_COLOR,
  'line-opacity': 0.5,
  'line-width': 7
};

export const CIRCLE_STROKE_WIDTH = 3;
export const CIRCLE_SELECTION_STYLE = {
  'circle-radius': 14,
  'circle-color': SELECTION_COLOR,
  'circle-opacity': 0.5,
  'circle-stroke-color': SELECTION_COLOR,
  'circle-stroke-opacity': 1,
  'circle-stroke-width': CIRCLE_STROKE_WIDTH
};

export const POLYGON_SELECTION_STYLE = {
  'fill-color': SELECTION_COLOR,
  'fill-opacity': 0.5,
  'fill-outline-color': SELECTION_COLOR
};

export const CIRCLE_STRATEGY: HighlightStrategy = {
  type: 'circle',
  paint: CIRCLE_SELECTION_STYLE
};

export const LINE_STRATEGY: HighlightStrategy = {
  type: 'line',
  paint: LINE_SELECTION_STYLE
};

export const POLYGON_STRATEGY: HighlightStrategy = {
  type: 'fill',
  paint: POLYGON_SELECTION_STYLE
};

// Maximum zoom level of web tiles
// https://developers.arcgis.com/documentation/mapping-and-location-services/reference/zoom-levels-and-scale/
export const TILES_MAX_ZOOM = 23;
